import React from 'react';

const SvgIncentiveBig = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
    <path
      fill="#FE544A"
      d="M18.1 1.54a3 3 0 013.8 0l1.46 1.2a3 3 0 002.37.63l1.86-.3a3 3 0 013.28 1.89l.67 1.76a3 3 0 001.74 1.74l1.76.67a3 3 0 011.9 3.28l-.3 1.86a3 3 0 00.63 2.37l1.19 1.47a3 3 0 010 3.78l-1.2 1.47a3 3 0 00-.63 2.37l.3 1.86a3 3 0 01-1.89 3.28l-1.76.67a3 3 0 00-1.74 1.74l-.67 1.76a3 3 0 01-3.28 1.9l-1.86-.3a3 3 0 00-2.37.63l-1.47 1.19a3 3 0 01-3.78 0l-1.47-1.2a3 3 0 00-2.37-.63l-1.86.3a3 3 0 01-3.28-1.89l-.67-1.76a3 3 0 00-1.74-1.74l-1.76-.67a3 3 0 01-1.9-3.28l.3-1.86a3 3 0 00-.63-2.37l-1.19-1.47a3 3 0 010-3.78l1.2-1.47a3 3 0 00.63-2.37l-.3-1.86a3 3 0 011.89-3.28l1.76-.67a3 3 0 001.74-1.74l.67-1.76a3 3 0 013.28-1.9l1.86.3a3 3 0 002.37-.63z"
    />
    <circle cx={20} cy={20} r={11.5} fill="#FFD46F" />
    <path
      fill="#FE544A"
      d="M24.22 21.3a2.92 2.92 0 110 5.83 2.92 2.92 0 010-5.83m-.68-6.26a1 1 0 111.42 1.42l-8.49 8.48a1 1 0 01-1.41-1.41zm.68 8.26a.92.92 0 100 1.83.92.92 0 000-1.83m-8.44-10.43a2.92 2.92 0 110 5.83 2.92 2.92 0 010-5.83m0 2a.92.92 0 100 1.83.92.92 0 000-1.83"
    />
  </svg>
);

export default SvgIncentiveBig;
